import React from 'react';

import { useFormikContext } from 'formik';

import { withErrorBoundary } from 'components/shared/Error/Boundary';
import ImageUploader from 'components/shared/ImageUploader/ImageUploader';

const AccountImage = ({ practice, setPractice }) => {
  const { setFieldValue } = useFormikContext();
  return (
    <div className="flex w-full items-center justify-between gap-5 border-b border-l-0 border-r-0 border-t-0 border-solid border-b-neutral-100 pb-5">
      <div className="flex w-1/2 flex-col gap-5 text-sm">
        <span className="font-500">Image</span>
        <p className="text-neutral-500">
          Add your practice logo or image of your brand. This image will be used through the system
          to customize it better with your brand.
        </p>
      </div>
      <ImageUploader
        className="mt-1 w-1/2"
        handlers={
          practice?.header_photo
            ? [JSON.parse(practice.header_photo)[Object.keys(JSON.parse(practice.header_photo))[0]]]
            : []
        }
        onDelete={() => {
          setPractice((prev) => ({ ...prev, header_photo: null }));
          setFieldValue('headerPhoto', null);
        }}
        onUpload={(file) => {
          const ext = file.name.split('.').pop();
          const minimal = { [ext]: file.handle };

          const header_photo = JSON.stringify(minimal);
          setPractice((prev) => ({ ...prev, header_photo }));
          setFieldValue('headerPhoto', header_photo);
        }}
      />
    </div>
  );
};

export default withErrorBoundary(AccountImage);
